// avstemming-tax-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'avg.common.ofCount': '{done} de {total}',
  'avg.derived.betaling_mangler': 'Las obligaciones vencidas sin pago están tratadas',
  'avg.derived.betalt_for_sent': 'Las obligaciones pagadas después del vencimiento están tratadas',
  'avg.derived.delvis_betalt': 'Las obligaciones pagadas parcialmente están tratadas',
  'avg.derived.bokforingsdifferanse': 'Las diferencias entre las obligaciones y la deuda contabilizada están tratadas',
  'avg.derived.ikke_bokfort': 'Las obligaciones sin deuda contabilizada están tratadas',
  'avg.derived.ikke_meldt': 'Los procesos de nómina no registrados como declarados están tratados',
  'avg.derived.mva_ikke_levert': 'Las liquidaciones de IVA no finalizadas están tratadas',
  'avg.derived.direktefort': 'Los asientos directos en las cuentas de control están evaluados',
  'avg.derived.uten_bankdekning': 'Los pagos sin confirmación en el extracto bancario están tratados',
  'avg.checklist.title': 'Lista de verificación profesional',
  'avg.checklist.titleReadOnly': 'Lista de verificación profesional (del responsable, solo lectura)',
  'avg.checklist.empty': 'No hay puntos de control definidos para impuestos y tasas públicas en este periodo.',
  'avg.checklist.intro': 'Los puntos se aplican a toda el área de impuestos. Una marca se guarda en todas las cuentas de control del periodo.',
  'avg.checklist.groupItems': 'Partidas que requieren tratamiento',
  'avg.checklist.processed': '{done} de {total} tratadas',
  'avg.checklist.notRelevant': 'No aplica en este periodo',
  'avg.checklist.autoTag': 'Se deriva de las evaluaciones',
  'avg.checklist.groupAssessment': 'Valoraciones profesionales generales',
  'avg.checklist.groupReady': 'Preparación',
  'avg.checklist.performedBy': 'Realizado por {name}',
  'avg.checklist.completed': '{done} de {total} puntos de control completados',
  'avg.blocker.itemsOne': '{count} asunto requiere evaluación',
  'avg.blocker.itemsMany': '{count} asuntos requieren evaluación',
  'avg.blocker.accounts': 'Cuentas de control que difieren de la base calculada: {count}',
  'avg.blocker.overdue': 'Obligaciones vencidas sin pagar: {count}',
  'avg.blocker.controlsOne': 'Queda {count} punto de control',
  'avg.blocker.controlsMany': 'Quedan {count} puntos de control',
  'avg.concl.title': 'Conclusión y aprobación',
  'avg.concl.label': 'Conclusión',
  'avg.concl.placeholder': '¿Qué muestra la revisión de impuestos y tasas públicas en este periodo?',
  'avg.concl.savedAs': 'Se guarda como justificación del punto de control «{label}».',
  'avg.concl.remainingRisk': 'Riesgo pendiente',
  'avg.concl.noBlockers': 'No queda nada que impida enviar el área a revisión. No se ha obtenido el resumen de obligaciones de Skatteetaten: la conciliación se ha hecho con las obligaciones calculadas por la propia empresa.',
  'avg.concl.followUpTitle': 'Seguimiento en el próximo periodo',
  'avg.concl.followUpEmpty': 'Ninguna evaluación está marcada para seguimiento en el próximo periodo.',
  'avg.concl.followUpBadge': 'En seguimiento',
  'avg.concl.measure': 'Medida: {value}',
  'avg.concl.noMeasure': 'Ninguna medida anotada',
  'avg.concl.deadline': 'Plazo {date}',
  'avg.concl.openAssessment': 'Abrir evaluación',
  'avg.concl.sendToControl': 'Enviar el área a revisión',
  'avg.concl.oneLeft': 'Queda una cosa antes de poder enviar el área.',
  'avg.concl.manyLeft': 'Quedan {count} cosas antes de poder enviar el área.',
  'avg.common.close': 'Cerrar',
  'avg.common.requestDocs': 'Pedir documentación al cliente',
  'avg.common.status': 'Estado',
  'avg.common.viewAssessment': 'Ver evaluación',
  'avg.common.assess': 'Evaluar',
  'avg.common.openPayroll': 'Abrir conciliación de nómina',
  'avg.common.openVat': 'Abrir conciliación de IVA',
  'avg.col.booked': 'Contabilizado',
  'avg.col.paid': 'Pagado',
  'avg.col.rest': 'Resto',
  'avg.col.assessment': 'Evaluación',
  'avg.col.due': 'Vencimiento',
  'avg.col.period': 'Periodo',
  'avg.col.difference': 'Diferencia',
  'avg.col.details': 'Detalles',
  'avg.col.date': 'Fecha',
  'avg.col.amount': 'Importe',
  'avg.col.claim': 'Obligación',
  'avg.drawer.due': 'Vencimiento {date}',
  'avg.drawer.calculatedClaim': 'Obligación calculada',
  'avg.drawer.rationale': 'Justificación profesional',
  'avg.drawer.rationaleRequired': 'Justificación profesional (obligatoria)',
  'avg.drawer.rationalePlaceholder': '¿Qué es el asunto y en qué se basa la evaluación?',
  'avg.drawer.measure': 'Medida',
  'avg.drawer.measurePlaceholder': 'P. ej. pagar la obligación, corregir la deuda en el justificante o pedir documentación',
  'avg.drawer.followUpDeadline': 'Plazo de seguimiento',
  'avg.drawer.followUpNext': 'Seguimiento en el próximo periodo',
  'avg.drawer.needsRationale': 'Esta evaluación requiere una justificación.',
  'avg.drawer.save': 'Guardar evaluación',
  'avg.status.incomplete': 'Incompleto',
  'avg.sources.title': 'Fuentes de datos',
  'avg.sources.missingOne': '{count} fuente no está completa para el periodo.',
  'avg.sources.missingMany': '{count} fuentes no están completas para el periodo.',
  'avg.sources.allPresent': 'Las fuentes que lee la conciliación están disponibles para el periodo.',
  'avg.sources.source': 'Fuente',
  'avg.sources.unavailable': 'No disponible',
  'avg.sources.complete': 'Completo',
  'avg.main.title': 'Conciliación principal automática',
  'avg.main.noAccount': 'Ninguna cuenta de control con base calculada',
  'avg.main.differenceOpen': 'La diferencia debe tratarse',
  'avg.main.matches': 'La deuda contabilizada coincide con las obligaciones',
  'avg.main.bookedBalance': 'Saldo contabilizado en cuentas de control',
  'avg.main.claims': 'Obligaciones calculadas y no pagadas',
  'avg.main.preliminaryDiff': 'Diferencia provisional',
  'avg.main.explained': 'Partidas explicadas en la conciliación',
  'avg.main.unexplained': 'Diferencia sin explicar',
  'avg.main.comparedOn': 'Comparado en {accounts}.',
  'avg.main.explainer': 'Las obligaciones son las calculadas por la propia empresa a partir de la nómina y el IVA, con vencimiento legal. La aplicación no obtiene el resumen de obligaciones de Skatteetaten.',
  'avg.main.openClaims': 'Obligaciones públicas abiertas',
  'avg.main.dueSoon': 'Vencen en los próximos 14 días',
  'avg.main.overdue': 'Vencidas al cierre del periodo',
  'avg.main.paidInPeriod': 'Pagado en el periodo',
  'avg.main.directPostings': 'Asientos directos en cuentas de control',
  'avg.main.claimsNoLiability': 'Obligaciones sin deuda contabilizada',
  'avg.main.openClaimsOverview': 'Abrir resumen de obligaciones',
  'avg.main.seePayments': 'Ver pagos',
  'avg.main.seeAccounts': 'Ver cuentas de control',
  'avg.accounts.title': 'Cuentas de control en el libro mayor',
  'avg.accounts.empty': 'No existe ninguna cuenta de control de impuestos y tasas públicas en este periodo.',
  'avg.accounts.status.stemmer': 'Coincide',
  'avg.accounts.status.ikke_sammenliknet': 'No comparada',
  'avg.accounts.status.ikke_relevant': 'No relevante',
  'avg.accounts.colAccount': 'Cuenta de control',
  'avg.accounts.colOpening': 'Saldo inicial',
  'avg.accounts.colDebit': 'Debe',
  'avg.accounts.colCredit': 'Haber',
  'avg.accounts.colClosing': 'Saldo final',
  'avg.accounts.colBasis': 'Base calculada',
  'avg.accounts.openAccount': 'Abrir cuenta',
  'avg.tile.betaling_mangler': 'Obligaciones vencidas sin pago',
  'avg.tile.betalt_for_sent': 'Pagado después del vencimiento',
  'avg.tile.bokforingsdifferanse': 'Diferencia contable respecto a la obligación',
  'avg.tile.ikke_bokfort': 'Obligaciones sin deuda contabilizada',
  'avg.tile.delvis_betalt': 'Obligaciones pagadas parcialmente',
  'avg.tile.ikke_meldt': 'Proceso de nómina no registrado como declarado',
  'avg.tile.mva_ikke_levert': 'Liquidación de IVA no finalizada',
  'avg.tile.direktefort': 'Asientos directos en cuenta de control',
  'avg.tile.uten_bankdekning': 'Pago sin cobertura bancaria',
  'avg.tile.betalt_etter_periode': 'Pagado después del cierre del periodo',
  'avg.ctl.title': 'Tarjeta de control',
  'avg.ctl.checksRun': 'Controles automáticos ejecutados: {count}',
  'avg.ctl.flagged': 'Asuntos que requieren evaluación: {count}',
  'avg.ctl.done': 'Evaluados por completo: {count}',
  'avg.ctl.accountsVsClaims': 'Cuentas de control frente a obligaciones',
  'avg.ctl.reconciledOf': '{done} de {total} conciliadas',
  'avg.ctl.accountsWithBasis': 'Cuentas con base calculada',
  'avg.ctl.activeFilter': 'Filtro activo: {label}',
  'avg.ctl.postsCount': 'Partidas: {count}',
  'avg.ctl.reset': 'Restablecer',
  'avg.checks.title': 'Controles automáticos',
  'avg.checks.intro': 'Los controles no marcan nada en la lista de verificación profesional. Indican qué debería haber revisado quien marca los puntos.',
  'avg.checks.colCheck': 'Control',
  'avg.checks.colRun': 'Ejecución',
  'avg.checks.colFindings': 'Hallazgos',
  'avg.checks.ran': 'Ejecutado',
  'avg.checks.findings': 'Hallazgos: {count}',
  'avg.checks.none': 'Sin hallazgos',
  'avg.common.yes': 'Sí',
  'avg.common.no': 'No',
  'avg.claims.titleEmpty': 'Obligaciones públicas del periodo',
  'avg.claims.empty': 'El periodo no tiene obligaciones públicas calculadas. Sin procesos de nómina ni período de IVA no hay obligaciones que conciliar.',
  'avg.claims.title': 'Obligaciones públicas: calculadas, contabilizadas y pagadas',
  'avg.claims.intro': 'Las obligaciones son las calculadas por la propia empresa, con vencimiento legal. El importe procede del proceso de nómina y de la declaración de IVA, no de un resumen de obligaciones de Skatteetaten: la aplicación no lo obtiene.',
  'avg.claims.colType': 'Tipo de obligación',
  'avg.claims.colCalculated': 'Calculado',
  'avg.claims.colBookedLiability': 'Deuda contabilizada',
  'avg.claims.colPayment': 'Pago',
  'avg.claims.colBooking': 'Contabilización',
  'avg.claims.draftCredit': 'Borrador: {amount} a favor',
  'avg.claims.draftPayable': 'Borrador: {amount} a pagar',
  'avg.claims.openVat': 'Abrir IVA',
  'avg.wh.title': 'Retención a cuenta: pago tras el pago de nómina',
  'avg.wh.runsWithWithholding': 'Procesos de nómina con retención a cuenta',
  'avg.wh.totalWithholding': 'Total de retención a cuenta',
  'avg.wh.paidInTime': 'Pagado dentro del plazo',
  'avg.wh.overdueUnpaid': 'Vencido sin pago',
  'avg.wh.paidLate': 'Pagado fuera de plazo',
  'avg.wh.colRun': 'Proceso de nómina',
  'avg.wh.colPayDate': 'Fecha de pago de nómina',
  'avg.wh.colWithholding': 'Retención a cuenta',
  'avg.wh.colDeadline': 'Plazo de pago',
  'avg.wh.colRegisteredPaid': 'Pago registrado',
  'avg.wh.colPaymentDate': 'Fecha de pago',
  'avg.wh.colAmelding': 'A-melding',
  'avg.wh.empty': 'Ningún proceso de nómina del periodo tiene retención a cuenta que pagar.',
  'avg.wh.note': 'A partir de 2026, la retención a cuenta y las retenciones por embargo se pagan directamente a Skatteetaten a más tardar el primer día hábil después del pago de la nómina. El plazo indicado arriba lo calcula el modelo de nómina, con los festivos noruegos. El pago es el registrado en el proceso: la aplicación no obtiene el KID de Skatteetaten.',
  'avg.aga.title': 'Cotización del empleador e impuesto financiero',
  'avg.aga.empty': 'No se ha calculado cotización del empleador para el período al que pertenece este periodo.',
  'avg.aga.computed': 'Calculado en el sistema de nómina',
  'avg.aga.cost': 'Gasto contabilizado (5400)',
  'avg.aga.liability': 'Deuda contabilizada (2770)',
  'avg.aga.term': 'Período',
  'avg.aga.deadline': 'Plazo de pago',
  'avg.aga.financeTax': 'Impuesto financiero',
  'avg.aga.financeTaxNote': 'No lo calcula el modelo de nómina',
  'avg.aga.bookingDifference': 'Diferencia contable',
  'avg.aga.noBooking': 'Sin contabilización con la que comparar',
  'avg.aga.matches': 'La cotización contabilizada coincide con el cálculo',
  'avg.aga.note': 'El movimiento es el del período, desde su inicio hasta el cierre del periodo. La cotización se devenga a lo largo del período, y el mes por sí solo compararía la mitad de los asientos del período con la cotización completa.',
  'avg.aga.documentExplanation': 'Documentar explicación',
  'avg.vat.title': 'IVA y liquidación',
  'avg.vat.empty': 'Ningún período de IVA cubre este periodo.',
  'avg.vat.intro': 'Los controles de transacciones de IVA se hacen en la conciliación de IVA: esta sección solo muestra el estado de la liquidación.',
  'avg.vat.reportingPeriod': 'Periodo de declaración',
  'avg.vat.net': 'IVA neto del período',
  'avg.vat.netCredit': '{amount} a favor',
  'avg.vat.netPayable': '{amount} a pagar',
  'avg.vat.settlementBalance': 'Contabilizado en la cuenta de liquidación',
  'avg.vat.dueDate': 'Plazo de presentación',
  'avg.vat.registeredPaid': 'Pago registrado',
  'avg.vat.termOver': 'El período termina en este periodo',
  'avg.ctax.title': 'Impuesto de sociedades e impuesto anticipado',
  'avg.ctax.payable': 'Impuesto a pagar (2500)',
  'avg.ctax.deferred': 'Impuesto diferido (2510)',
  'avg.ctax.prepaid': 'Impuesto anticipado (2540)',
  'avg.ctax.cost': 'Gasto por impuestos contabilizado en el año hasta la fecha (8300)',
  'avg.ctax.note': 'La provisión de impuestos es un cálculo contable. La conciliación externa se hace con el aviso de anticipo, la liquidación de impuestos u otra obligación de Skatteetaten; Plumme no obtiene ninguno de ellos, por lo que las cuentas aparecen como «no comparadas» en la tabla de cuentas de control. El siguiente control pertinente es el cierre anual o una nueva liquidación de impuestos.',
  'avg.flag.betaling_mangler': 'Vencido: sin pagar',
  'avg.flag.delvis_betalt': 'Pagado parcialmente',
  'avg.flag.betalt_for_sent': 'Pagado después del vencimiento',
  'avg.flag.betalt_etter_periode': 'Pagado después del cierre del periodo',
  'avg.flag.bokforingsdifferanse': 'Diferencia contable',
  'avg.flag.ikke_bokfort': 'No contabilizado como deuda',
  'avg.flag.ikke_meldt': 'Proceso de nómina no registrado como declarado',
  'avg.flag.mva_ikke_levert': 'Declaración de IVA no presentada',
  'avg.flag.direktefort': 'Asiento directo en cuenta de control',
  'avg.flag.uten_bankdekning': 'Pago no confirmado por el banco',
  'avg.assessment.ikke_vurdert': 'Sin evaluar',
  'avg.assessment.ingen_korrigering': 'No se necesita corrección',
  'avg.assessment.tidsforskjell': 'Diferencia temporal',
  'avg.assessment.feil_bokforing': 'Error contable',
  'avg.assessment.manglende_betaling': 'Pago pendiente',
  'avg.assessment.manglende_bokforing': 'Contabilización pendiente',
  'avg.assessment.feil_kobling': 'Vínculo erróneo con la obligación',
  'avg.assessment.tilbakebetaling': 'Reembolso o compensación',
  'avg.assessment.rente': 'Reclamación de intereses',
  'avg.assessment.bankgebyr': 'Comisión',
  'avg.assessment.avventer_dokumentasjon': 'A la espera de documentación',
  'avg.assessment.avventer_klienten': 'A la espera del cliente',
  'avg.assessment.ikke_relevant': 'No relevante',
  'avg.assessment.neste_periode': 'Seguimiento en el próximo periodo',
  'avg.quick.krever_vurdering': 'Requiere evaluación',
  'avg.quick.all': 'Todos',
  'avg.quick.betaling_mangler': 'Falta el pago',
  'avg.quick.betalt_for_sent': 'Pagado tarde',
  'avg.quick.bokforingsdifferanse': 'Diferencia contable',
  'avg.quick.ikke_bokfort': 'No contabilizado',
  'avg.quick.ikke_meldt': 'A-melding',
  'avg.quick.direktefort': 'Asientos directos',
  'avg.quick.uten_bankdekning': 'Sin cobertura bancaria',
  'avg.quick.ferdig_vurdert': 'Evaluado por completo',
  'avg.quick.confirmed': 'Confirmado por el banco',
  'avg.quick.registrert': 'Registrado contra la obligación',
  'avg.quick.etter_frist': 'Pagado fuera de plazo',
  'avg.quick.etter_periode': 'Después del cierre del periodo',
  'avg.flagBadges.none': 'Ninguno',
  'avg.flagBadges.more': '+{count} más',
  'avg.match.registrert': 'Registrado contra la obligación',
  'avg.match.etter_frist': 'Registrado: después del vencimiento',
  'avg.match.etter_periode': 'Registrado: después del cierre del periodo',
  'avg.match.direktefort': 'Asiento directo: ninguna fuente lo respalda',
  'avg.pay.title': 'Pagos y asientos en las cuentas de control',
  'avg.pay.intro': 'Los pagos son las liquidaciones registradas por la propia empresa contra las obligaciones. Si el pago está casado con una línea bancaria en la conciliación bancaria, es el extracto bancario el que confirma que el dinero salió de la cuenta: la única fuente externa de esta área. Los asientos directos son asientos en las cuentas de control que no proceden de un proceso de nómina, de un pago de impuestos registrado ni de una liquidación de IVA: una comisión, un interés o una corrección manual.',
  'avg.pay.colDescription': 'Descripción',
  'avg.pay.colApplies': 'Se refiere a',
  'avg.pay.colBank': 'Cobertura bancaria',
  'avg.pay.colVoucher': 'Justificante',
  'avg.pay.bankLine': 'Línea bancaria {date}',
  'avg.pay.notMatched': 'Sin casar',
  'avg.pay.noStatement': 'Sin extracto bancario',
  'avg.pay.empty': 'Ningún pago o asiento coincide con los filtros.',
  'avg.items.title': 'Desviaciones y medidas',
  'avg.items.clearFilters': 'Borrar filtros',
  'avg.items.colMatter': 'Asunto',
  'avg.items.colAlert': 'Aviso',
  'avg.items.empty': 'Ningún asunto coincide con los filtros.',
  'avg.docs.notFetched': 'La aplicación no lo obtiene',
  'avg.docs.inPlace': 'Disponible',
  'avg.docs.title': 'Documentación',
  'avg.docs.colBasis': 'Base',
  'avg.docs.requestFromCustomer': 'Pedir documentación al cliente',
  'avg.docs.attached': 'Documentación adjunta',
  'avg.docs.attachedEmpty': 'No se ha subido ningún documento en el área de impuestos para este periodo.',
  'avg.page.noAccount': 'El área de impuestos no tiene cuenta de conciliación en este periodo.',
  'avg.nav.differences': 'Diferencias: {count}',
  'avg.nav.matches': 'Coincide',
  'avg.nav.overview': 'Resumen',
  'avg.nav.claims': 'Obligaciones y saldo',
  'avg.nav.claimsCount': 'Obligaciones: {count}',
  'avg.nav.withholding': 'Retención a cuenta',
  'avg.nav.toAssess': 'Por evaluar: {count}',
  'avg.nav.runs': 'Procesos: {count}',
  'avg.nav.aga': 'Cotización del empleador',
  'avg.nav.oneDifference': '1 diferencia',
  'avg.nav.filed': 'Presentada',
  'avg.nav.notFiled': 'No presentada',
  'avg.nav.corporateTax': 'Impuesto de sociedades',
  'avg.nav.noExternalSource': 'Sin fuente externa',
  'avg.nav.payments': 'Pagos',
  'avg.nav.entries': 'Partidas: {count}',
  'avg.nav.open': 'Abiertas: {count}',
  'avg.nav.missing': 'Faltan: {count}',
  'avg.nav.controls': 'Revisión y aprobación',
  'avg.page.areaLabel': 'Impuestos y tasas públicas',
  'avg.page.hintOpen': 'Asuntos con aviso sin evaluar por completo: {count}.',
  'avg.page.hintDone': 'Todos los asuntos con aviso están evaluados.',
  'avg.page.heading': 'Impuestos y tasas públicas: obligaciones, contabilización y pago',
  'avg.page.vatTerm': 'Período de IVA {n} ({period})',
  'avg.page.responsible': 'Responsable {name}',
  'avg.page.overdueBadge': 'Obligaciones vencidas sin pago: {count}',
  'avg.page.noOpen': 'Ningún asunto abierto',
  'avg.page.claimsSource': 'Las obligaciones se obtienen de los procesos de nómina y de la declaración de IVA, con vencimiento legal.',
  'avg.page.claimsChecked': 'Obligaciones comprobadas con la contabilidad: {claims}. Asuntos que requieren evaluación: {unassessed}.',
  'avg.page.notFetchedInfo': 'Plumme no obtiene de Skatteetaten el resumen de obligaciones, el saldo ni el KID. La conciliación compara las obligaciones calculadas por la propia empresa con la contabilidad y los pagos registrados. Una obligación fijada por Skatteetaten debe comprobarse manualmente con la cuenta de impuestos.',
});
